<p-select [options]="options" optionLabel="name" optionValue="value" *ngIf="value !== 'query_view'" appendTo="body"
    [(ngModel)]="value" class="form-control form-control-sm" placeholder="Select" (onChange)="onTblTypChange($event)"
    [disabled]="disableField || value ==='query_view'">
    <ng-template let-possibleValue pTemplate="item">
        <div class="value-item" [ngClass]="possibleValue.value">
            <div>{{possibleValue.name}}</div>
        </div>
    </ng-template>
</p-select>

<input type="text" *ngIf="value === 'query_view'" pInputText [(ngModel)]="queryView" readonly />